import { surveyInstance } from '..';

const getAnswers = async (officerId) => {
  const { data } = await surveyInstance('/answers/officer/', { params: { officerId } });
  return data;
};

export default getAnswers;
